import React, { FC } from 'react';
import styled from 'styled-components/macro';
import { Route, Switch } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { SmallText } from '@hox/ui/Typography';
import { Logo } from '@hox/ui/Logo';
import { AuthCard } from 'components/AuthCard';
import { QueryParamError } from 'views/QueryParamError';
import { Logout } from 'views/Logout';
import { Login } from 'views/Login';

interface IAppProps {}

const AppStyled = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  min-height: 27.5rem; /*440px*/
  box-sizing: border-box;
  padding: 1rem;

  > * {
    margin-bottom: 2rem;
    :last-child {
      margin-bottom: 0;
    }
  }
`;

const Content = styled.div`
  display: block;
  width: 100%;
  max-width: 30rem;
`;

const App: FC<IAppProps> = () => {
  return (
    <AppStyled data-test-id="auth-container">
      <Logo />
      <Content>
        <AuthCard>
          <Switch>
            <Route exact path="/error" component={QueryParamError} />
            <Route exact path="/logout" component={Logout} />
            <Route exact path="*" component={Login} />
          </Switch>
        </AuthCard>
      </Content>
      <SmallText>
        <FormattedMessage
          id="auth.app.supportEmail"
          defaultMessage="{supportEmailAddress}"
          description="Support email address on all views"
          values={{ supportEmailAddress: 'support@hoxhunt.com' }}
        />
      </SmallText>
    </AppStyled>
  );
};

export default App;
